import * as React from 'react';
import SVG from 'react-inlinesvg';
import { Route } from 'react-router-dom';

import { getHomePageRoute } from '../../../../infrastructure/HomePageRoute';
import { IUserData, IDocument } from '../../../../infrastructure/interfaces';
import Zoom from '../common/Zoom';
import PageNavigation from '../common/PageNavigation';
import NavigationButtons from '../common/NavigationButtons';

const home = require('./images/home.svg');


export interface IResultHeaderProps {
  isSpreadView: boolean;
  userData: IUserData;
  document: IDocument;
}

export default class ResultHeader extends React.Component<IResultHeaderProps> {
  render() {
    const homePageRoute = getHomePageRoute(this.props.userData.role);

    return (
      <div className="header result-header">
        <div className="result-header-left">
          <Zoom handleZoom={undefined}/>
          <Route
            render={({ history }) => {
              return (
                <button className="result-header-home"
                  onClick={() => history.push(homePageRoute)}>
                  <span>
                    {<SVG src={home}></SVG>}
                    Home
                  </span>
              </button>);
            }}
          />
        </div>
        <div className={`result-header-right ${this.props.document.type}`}>
          <PageNavigation className="result-header-center"
              pages={undefined}
              spreads={undefined}
              isSpreadView={false}
              selectedPage={undefined}
              selectedSpread={undefined}
              selectPage={undefined}
              selectSpread={undefined}
              showNavButtons={true}
            />
            <NavigationButtons resultView={true}
              document={null}
              userData={this.props.userData}
              statesList={null}/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/Result/ResultHeader.tsx